import { render, staticRenderFns } from "./CustomerInformationScreen.vue?vue&type=template&id=62f0fb0e&scoped=true"
import script from "./CustomerInformationScreen.vue?vue&type=script&lang=js"
export * from "./CustomerInformationScreen.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformationScreen.vue?vue&type=style&index=0&id=62f0fb0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0fb0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f0fb0e')) {
      api.createRecord('62f0fb0e', component.options)
    } else {
      api.reload('62f0fb0e', component.options)
    }
    module.hot.accept("./CustomerInformationScreen.vue?vue&type=template&id=62f0fb0e&scoped=true", function () {
      api.rerender('62f0fb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sinvoice_viettel/CustomerInformationScreen.vue"
export default component.exports